import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AppBar, Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, Toolbar, Link, Grid, Slide } from '@material-ui/core'
import { ArrowDropDown, OpenInNew } from '@material-ui/icons';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';

import TelemedicineBanner from '../../components/TelemedicineBanner';
import * as api from '../../services/api/admin';
import * as authApi from '../../services/api/auth';

function AdminHeader(props) {
  const {
    enqueueSnackbar,
    onLogout,
    classes: {
      appBar,
      practice,
      settingsMenuButton,
      dropdown,
      menuItem,
      icon,
      adminText,
      paper,
      menuLink,
    },
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMasquerading, setIsMasquerading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [currentPractice, setCurrentPractice] = useState({});
  const [hasTelemedicineUrl, setHasTelemedicineUrl] = useState(false);
  const [appbarHidden, setAppBarHidden] = useState(false)
  const [modal,setModal] = useState(false)
  let fetchedCurrentPractice
  let fetchedCurrentUser

  const handleIsMasquerading = () => {
    return Cookies.get('is-masquerading');
  };
  useEffect(() => {
    (async () => {
      const fetchedMasquerading = handleIsMasquerading();
      setIsMasquerading(fetchedMasquerading);
      fetchedCurrentUser = await authApi.fetchCurrentUser();
      setCurrentUser(fetchedCurrentUser);
      fetchedCurrentPractice = await authApi.fetchCurrentPractice();
      setCurrentPractice(fetchedCurrentPractice);
      handleHasTelemedicineUrl();
    })();
  }, []);


  const handleHasTelemedicineUrl = () => {
    if (fetchedCurrentUser) {
      const virtualTenancy = fetchedCurrentUser.provider.tenancies.filter(tenancy => {
        return !!tenancy.virtualRoomUrl;
      });
      if (virtualTenancy.length > 0) {
        setHasTelemedicineUrl(true);
      } else {
        setHasTelemedicineUrl(false);
      }
    }
  };

  const stopMasquerading = async () => {
    try {
      await api.deleteMasquerade();
      window.location.href = '/admin/admin';
    } catch (err) {
      console.error(err);
      enqueueSnackbar(
        'Undoing SuperAdmin failed. Please try again or log out to get back normal.'
      );
    }
  };

  const handleClick = event => {
    setModal(!modal);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setModal(!modal);
    // setAnchorEl(null);
  };

  const handleScroll = () => {
    if (window) {
      if (window.scrollY > 50 && window.innerWidth < 600) {
            setAppBarHidden(true)
      } else if (window.scrollY === 0) {
        setAppBarHidden(false)
      }
    }
  };

  React.useEffect(()=>{
    if (window) {
      window.addEventListener("scroll", handleScroll)
    };
    return () => {
      window.removeEventListener("scroll", handleScroll)
    };
  }, []);

  return (
    <Slide
      direction="down"
      in={!appbarHidden}
      className="headerMain"
    >
      <AppBar
        position='relative'
        color={isMasquerading ? 'secondary' : 'primary'}
        classes={{ root: appBar }}
      >
       
        <Toolbar>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} md={3} classes={{ item: practice }}>
              <h4>{currentPractice.name}</h4>
            </Grid>
            <div className="userLogOutBtn">
            <Grid item xs={12} md={9}>
              <Grid container justifyContent="flex-end">
                <Grid item xs={12} md={8}>
                  {isMasquerading && (
                    <div>
                      <span className={adminText}>
                        SuperAdmin Mode, Be Careful!
                      </span>
                      <Button
                        variant="outlined"
                        color="inherit"
                        onClick={stopMasquerading}
                      >
                        Click Here To Go Back
                      </Button>
                    </div>
                  )}
                </Grid>

                <Grid item xs={12} md={4} classes={{ item: dropdown }}>
                  <Button
                    aria-owns={anchorEl ? 'settings' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    classes={{ root: settingsMenuButton }}
                  >
                    {currentUser.name}
                    <ArrowDropDown />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            </div>
          </Grid>

          {modal && <Popper
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="settings"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper className={paper}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList>
                      <MenuItem className={menuItem}>
                        <Link
                          href={
                            process.env.REACT_APP_HOMEPAGE_URL +
                            '/provider-user-agreement/'
                          }
                          target="_blank"
                          className={menuLink}
                          onClick={()=>setModal(false)}
                        >
                          Terms of Use
                          <OpenInNew className={icon} />
                        </Link>
                      </MenuItem>

                      <MenuItem className={menuItem}>
                        <Link
                          href={
                            process.env.REACT_APP_HOMEPAGE_URL +
                            '/privacy-policy/'
                          }
                          target="_blank"
                          className={menuLink}
                          onClick={()=>setModal(false)}
                        >
                          Privacy Policy
                          <OpenInNew className={icon} />
                        </Link>
                      </MenuItem>

                      {currentUser.admin && (
                        <MenuItem className={menuItem}>
                          <NavLink to="/admin/admin" className={menuLink} onClick={()=>setModal(false)}>
                            Super Admin
                          </NavLink>
                        </MenuItem>
                      )}

                      {currentUser.admin && (
                         <MenuItem className={menuItem}>
                         <NavLink to="/admin/admin/addmember" className={menuLink} onClick={()=>setModal(false)}>
                           Add Member To Provider
                         </NavLink>
                       </MenuItem>
                      )}
                       {currentUser.admin && (
                         <MenuItem className={menuItem}>
                         <NavLink to="/admin/admin/paymentsList" className={menuLink} onClick={()=>setModal(false)}>
                         SALIVA Plan Payment
                         </NavLink>
                       </MenuItem>
                      )}

                      {currentUser.admin && (
                        <MenuItem className={menuItem}>
                          <NavLink
                            to="/admin/admin/consult-notes"
                            className={menuLink}
                            onClick={()=>setModal(false)}
                          >
                            Consult Notes Beta
                          </NavLink>
                        </MenuItem>
                      )}
                      {currentUser.admin && (
                        <MenuItem className={menuItem}>
                          <NavLink
                            to="/admin/admin/appointment-requests"
                            className={menuLink}
                            onClick={()=>setModal(false)}
                          >
                            Appointment Requests Beta
                          </NavLink>
                        </MenuItem>
                      )}

                      <MenuItem onClick={onLogout} className={menuItem}>
                        Log Out
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>}
        </Toolbar>
   
        {/* <TelemedicineBanner hasTelemedicineUrl={hasTelemedicineUrl} /> */}
      </AppBar>
    </Slide>
  )
}


const styles = () => ({
  appBar: {
    height: '100px',
    width: '100%',
    zIndex: '1001',
    position: 'fixed',
    top: 0,
    left: 0,
    justifyContent: 'center',
    borderBottom: '1px solid #eaeaea',
    boxShadow: '0 0 4px rgba(193, 193, 193, 0.35)',
    
  },
  practice: {
    paddingLeft: '1em',
  },
  settingsMenuButton: {
    color: 'white',
  },
  dropdown: {
    textAlign: 'right',
  },
  menuItem: {
    padding: '0.5rem 2.5rem',
  },
  icon: {
    paddingLeft: '0.3em',
    fontSize: '1.5em',
  },
  adminText: {
    paddingRight: '1em',
    paddingLeft: '2em',
  },
});

export default withSnackbar(withStyles(styles)(AdminHeader));
